<!-- Hero Section -->
    <section class="hero-section">
        <div class="hero-container">
            <div class="announcement-badge">
                🎉 Announcement: 2026 Bookings Are Now Open
            </div>

            <h1 class="hero-title">
                GCSE Mock Tests
                <span>Real Exam Practice Across Multiple Centres</span>
            </h1>

            <div class="exam-boards">
                <span class="board-badge">AQA</span>
                <span class="board-badge">EDEXCEL</span>
                <span class="board-badge">OCR</span>
            </div>

            <div class="delivery-modes-hero">
                <span class="mode-pill">Face to Face</span>
                <span class="mode-pill">Online</span>
                <span class="mode-pill">Paper at Home</span>
            </div>

            <div class="cta-buttons">
                <button class="btn-primary" (click)="scrollToCalendar()">
                    Book Now
                    <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                </button>
                <button class="btn-secondary" (click)="downloadCalendar()">
                    <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                        <polyline points="7 10 12 15 17 10"></polyline>
                        <line x1="12" y1="15" x2="12" y2="3"></line>
                    </svg>
                    Download Schedule
                </button>
            </div>

            <div class="offers-banner">
                <div class="offers-text">
                    Explore our exciting offers on GCSE Mock Tests
                </div>
                <button class="btn-offer" [routerLink]="['/offer-free-resources']">
                    Claim Offers →
                </button>
            </div>

            <!-- Centers Section in Hero -->
            <div class="centers-in-hero">
                <div class="centers-grid-hero">
                    <div class="center-card-hero"  [routerLink]="['/location/redbridge-ilford-gcse-mocks']">
                        <h3 class="center-name-hero">Redbridge: Ilford</h3>
                        <p class="center-exams-hero">AQA, OCR & EDEXCEL</p>
                    </div>

                    <div class="center-card-hero" [routerLink]="['/location/essex-chelmsford-gcse-mocks']">
                        <h3 class="center-name-hero">Essex: Chelmsford</h3>
                        <p class="center-exams-hero">AQA, OCR & EDEXCEL</p>
                    </div>

                    <div class="center-card-hero" [routerLink]="['/location/essex-basildon-gcse-mocks']">
                        <h3 class="center-name-hero">Essex: Basildon</h3>
                         <p class="center-exams-hero">AQA, OCR & EDEXCEL</p>
                    </div>

                    <div class="center-card-hero" [routerLink]="['/location/essex-southend-on-sea-gcse-mocks']">
                        <h3 class="center-name-hero">Essex: Southend</h3>
                         <p class="center-exams-hero">AQA, OCR & EDEXCEL</p>
                    </div>

                    <div class="center-card-hero" (click)="scrollToCalendar()">
                        <h3 class="center-name-hero">Kent: Bexley</h3>
                         <p class="center-exams-hero">AQA, OCR & EDEXCEL</p>
                    </div>

                    <div class="center-card-hero" (click)="scrollToCalendar()">
                        <h3 class="center-name-hero">Bucks: Amersham</h3>
                         <p class="center-exams-hero">AQA, OCR & EDEXCEL</p>
                    </div>

                    <div class="center-card-hero" (click)="scrollToCalendar()">
                        <h3 class="center-name-hero">Bucks: Milton Keynes</h3>
                         <p class="center-exams-hero">AQA, OCR & EDEXCEL</p>
                    </div>

                    <div class="center-card-hero" (click)="scrollToCalendar()">
                        <h3 class="center-name-hero">Harrow</h3>
                         <p class="center-exams-hero">AQA, OCR & EDEXCEL</p>
                    </div>
                </div>
            </div>

            <p class="hero-subtitle">
              Our GCSE mock exams are held across multiple UK centres, including Harrow, Ilford, Chelmsford, Basildon, Southend, Amersham, Milton Keynes and Bexley, providing comprehensive coverage for all major GCSE exam boards such as AQA, Edexcel and OCR.

            </p>
        </div>
    </section>

    <!-- Test Categories -->
    <section class="categories-section">
        <div class="section-header">
            <h2 class="section-title">GCSE Mock Test Categories</h2>
            <p class="section-subtitle">Choose the right mock test for your exam preparation journey</p>
        </div>

        <div class="cards-grid">
            <!-- Card 1 -->
            <div class="test-card">
                <div class="card-header">
                    <h3 class="card-title">GCSE Full Mock Test</h3>
                    <span class="card-type">MOCK EXAM</span>
                </div>
                <div class="card-body">
                    <div class="info-grid">
                        <div class="info-item">
                            <div class="info-icon">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0077b6" stroke-width="2">
                                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                                </svg>
                            </div>
                            <div class="info-content">
                                <div class="info-label">Delivery Mode</div>
                                <div class="mode-tags">
                                    <span class="tag">Face-to-Face</span>
                                    <span class="tag">Online</span>
                                </div>
                            </div>
                        </div>
                        <div class="info-item">
                            <div class="info-icon">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0077b6" stroke-width="2">
                                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                    <line x1="16" y1="2" x2="16" y2="6"></line>
                                    <line x1="8" y1="2" x2="8" y2="6"></line>
                                    <line x1="3" y1="10" x2="21" y2="10"></line>
                                </svg>
                            </div>
                            <div class="info-content">
                                <div class="info-label">Schedule</div>
                                <div class="info-value">January – April</div>
                            </div>
                        </div>
                    </div>
                    <div class="card-actions">
                        <button class="action-btn action-primary" (click)="scrollToCalendar()">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                            View Schedule
                        </button>
                        <button class="action-btn action-outline" (click)="downloadCalendar()">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                <polyline points="7 10 12 15 17 10"></polyline>
                                <line x1="12" y1="15" x2="12" y2="3"></line>
                            </svg>
                            Download Schedule
                        </button>
                    </div>
                </div>
            </div>

            <!-- Card 2 -->
            <div class="test-card">
                <div class="card-header">
                    <h3 class="card-title">GCSE Mini Mock Test</h3>
                    <span class="card-type">MOCK EXAM</span>
                </div>
                <div class="card-body">
                    <div class="info-grid">
                        <div class="info-item">
                            <div class="info-icon">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0077b6" stroke-width="2">
                                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                                </svg>
                            </div>
                            <div class="info-content">
                                <div class="info-label">Delivery Mode</div>
                                <div class="mode-tags">
                                    <span class="tag">Face-to-Face</span>
                                    <span class="tag">Online</span>
                                </div>
                            </div>
                        </div>
                        <div class="info-item">
                            <div class="info-icon">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0077b6" stroke-width="2">
                                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                    <line x1="16" y1="2" x2="16" y2="6"></line>
                                    <line x1="8" y1="2" x2="8" y2="6"></line>
                                    <line x1="3" y1="10" x2="21" y2="10"></line>
                                </svg>
                            </div>
                            <div class="info-content">
                                <div class="info-label">Schedule</div>
                                <div class="info-value">October – December</div>
                            </div>
                        </div>
                    </div>
                    <div class="card-actions">
                        <button class="action-btn action-primary" (click)="scrollToCalendar()">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                            View Schedule
                        </button>
                        <button class="action-btn action-outline" (click)="downloadCalendar()">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                <polyline points="7 10 12 15 17 10"></polyline>
                                <line x1="12" y1="15" x2="12" y2="3"></line>
                            </svg>
                            Download Schedule
                        </button>
                    </div>
                </div>
            </div>

        </div>
    </section>

    <!-- Centers Section -->
    <section class="centers-section">
        <div class="section-header">
            <h2 class="section-title">Our Exam Centres</h2>
            <p class="section-subtitle">Find your nearest testing location</p>
        </div>

        <div class="centers-grid">
            <div class="center-card" onclick="viewLocation('redbridge')">
                <h3 class="center-name">Redbridge: Ilford</h3>
                <p class="center-exams">CSSE, FSCE, GL Redbridge, GL QE Boys, GL HBS Girls</p>
            </div>

            <div class="center-card" onclick="viewLocation('chelmsford')">
                <h3 class="center-name">Essex: Chelmsford</h3>
                <p class="center-exams">CSSE & FSCE (CCHS)</p>
            </div>

            <div class="center-card" onclick="viewLocation('basildon')">
                <h3 class="center-name">Essex: Basildon</h3>
                <p class="center-exams">CSSE & FSCE (CCHS)</p>
            </div>

          </div>
          
    </section>

<div class="cal-inst">
  <h3>Mock Test Calender</h3>
  <p>SELECT THE DATE/CENTER BELOW & CLICK BOOK BUTTON</p>
</div>

<!-- CALENDAR SECTION STARTS HERE -->

<section class="mock-calendar" id="calendar-section">
  <!-- FILTER TOOLBAR -->
  <div class="toolbar container-fluid">
    <div class="toolbar-row">
      <!-- Category -->
      <div class="toolbar-item">
        <label>Test Category</label>
        <div class="dropdown-like">
          <select [(ngModel)]="filters.categoryId" (change)="applyFilters()">
            <option [ngValue]="null">All</option>
            <option
              *ngFor="let c of gcseCategories"
              [ngValue]="c.category_name"
            >
              {{ c.category_name }}
            </option>
          </select>

          <span class="chev">▾</span>
        </div>
      </div>

      <!-- Pattern -->
      <div class="toolbar-item">
        <label>Test Pattern</label>
        <div class="dropdown-like">
          <select
            class="form-select"
            [(ngModel)]="filters.pattern"
            (change)="applyFilters()"
          >
            <option [ngValue]="null">All</option>
            <option *ngFor="let p of patterns" [ngValue]="p">
              {{ p }}
            </option>
          </select>
          <span class="chev">▾</span>
        </div>
      </div>

      <!-- Mode -->
      <div class="toolbar-item">
        <label>Test Mode</label>
        <div class="dropdown-like">
          <select
            class="form-select"
            [(ngModel)]="filters.mode"
            (change)="applyFilters()"
          >
            <option [ngValue]="null">Both</option>
            <option value="Online Session">Online</option>
            <option value="Classroom Session">Face to Face</option>
          </select>
          <span class="chev">▾</span>
        </div>
      </div>

      <!-- Months -->
      <div class="toolbar-item">
        <label>Months</label>
        <div class="dropdown-like">
          <select
            class="form-select"
            [(ngModel)]="filters.month"
            (change)="applyFilters()"
          >
            <option [ngValue]="null">Any</option>
            <option *ngFor="let m of months" [ngValue]="m.value">
              {{ m.label }}
            </option>
          </select>
          <span class="chev">▾</span>
        </div>
      </div>

      <!-- Center -->
      <div class="toolbar-item">
        <label>Center</label>
        <div class="dropdown-like">
          <select
            class="form-select"
            [(ngModel)]="filters.center"
            (change)="applyFilters()"
          >
            <option [ngValue]="null">Any</option>
            <option *ngFor="let l of centers" [ngValue]="l">{{ l }}</option>
          </select>
          <span class="chev">▾</span>
        </div>
      </div>

      <!-- Reset -->
      <div class="toolbar-item">
        <label>Reset Filters</label>
        <div class="dropdown-like">
          <button class="reset-btn" (click)="resetFilters()">Reset</button>
        </div>
      </div>
    </div>

    <!-- Search -->
    <div class="search-item">
      <label>Search</label>
      <input
        type="text"
        type="text"
        class="form-control search-input"
        placeholder="Search GCSE tests by name, location, type…"
        [(ngModel)]="filters.search"
        (input)="applyFilters()"
      />
    </div>
  </div>

  <!-- LIST BODY -->
  <div class="test-card-listing-body container list-body">
    <ng-container *ngIf="testList && testList.length > 0; else nothingFound">
      <div class="session-card test-card" *ngFor="let t of testList">
        <!-- Date -->
        <div class="date-chip">
          <span>{{ trimChar(t.test_date, 11) }}</span>
        </div>

        <!-- Session Info -->
        <div class="session-info">
          <a class="session-title">{{ t.category || "GCSE Test" }}</a>
          <a class="session-subtitle">
            <span [ngClass]="getPatternClass(t.test_name)">
              {{ getPatternFromName(t.test_name) }}
            </span>
          </a>
          <a class="session-pattern">{{ t.test_name }}</a>
        </div>

        <!-- Badges -->
        <div class="badges">
          <span
            class="badge"
            [ngClass]="
              t.exam_type === 'Online Session' ? 'badge-online' : 'badge-ff'
            "
          >
            {{ t.exam_type === "Online Session" ? "Online" : "Face to Face" }}
          </span>

          <span *ngIf="t.location || t.all_location" class="location-badge">
            <img src="assets/images/pin.png" alt="" />
            <span class="truncate" [title]="t.all_location || t.location">
              {{ trimChar(t.all_location || t.location) }}
            </span>
          </span>
        </div>

        <!-- Price -->
        <div class="price">
          <ng-container *ngIf="t.payment_method === 'Free'; else priced">
            Free
          </ng-container>
          <ng-template #priced>Price: £{{ t.test_fees }}</ng-template>
        </div>

        <!-- Book Button -->
        <div class="action">
          <a
            class="btn btn-book"
            [routerLink]="[
              '/11plus-help-club/category/',
              t.category_slug,
              t.test_slug
            ]"
          >
            Book
          </a>
        </div>
      </div>
    </ng-container>

    <ng-template #nothingFound>
      <div class="text-center py-5">No GCSE Test Found</div>
    </ng-template>
  </div>
</section>

<!-- CALENDAR ENDS HERE -->

<div class="af-ts">
  <h4>
    With more than a decade of experience we’ve helped <br />
    <strong>10,000+</strong> students improve their scores & ace their
    <strong>GCSEs</strong>!
  </h4>
</div>

<!-- FEATURE SECTIONS -->

<div class="ft-sc">
  <p class="ft-sc-title">What's Included in Your Mock Test?</p>

  <div class="ft-sc-info">
    <div class="ft-sc-item left">
      <img src="assets/images/f1.png" alt="" />
      <h5>Real Exam Like Environment</h5>
      <p>Timed & structured like actual GCSE Exams</p>
    </div>

    <div class="ft-sc-item">
      <img src="assets/images/f2.png" alt="" />
      <h5>Results Analysis Report (RAR)</h5>
      <p>Paper reviewed & marked with comments by GCSE specialist</p>
    </div>

    <div class="ft-sc-item right">
      <img src="assets/images/f3.png" alt="" />
      <h5>Take Your Test Paper Home</h5>
      <p>Review your errors & mistakes</p>
    </div>
  </div>

  <div class="ft-sc-info">
    <div class="ft-sc-item left">
      <img src="assets/images/f4.png" alt="" />
      <h5>Covers AQA, Edexcel, OCR Boards</h5>
      <p>Tailored to your exam board</p>
    </div>

    <div class="ft-sc-item">
      <img src="assets/images/f5.png" alt="" />
      <h5>Instant & Detailed Feedback</h5>
      <p>Identify strengths & weaknesses</p>
    </div>

    <div class="ft-sc-item right">
      <img src="assets/images/f6.png" alt="" />
      <h5>Consulting & Support</h5>
      <p>Post exam guidance & support from GCSE specialists</p>
    </div>
  </div>
</div>

<div class="co-sc">
  <p class="co-sc-title">
    Join the Community of <br />
    <span>10K+ Successful Students & Happy Parents!</span>
  </p>

  <div class="ts-sc">
    <div class="card-ts">
      <h4 style="font-weight: bold">Jaya Rani</h4>

      <p style="text-align: justify">
        My son did Sehyog Mock Test, it’s very helpful to know which areas my
        son is lacking. Sehyog result analysis gives us understanding on which
        area the aspirant/parent needs to improve and concentrate on, which is
        very important in 11 plus journey, apart from that Sehyog also provides
        you guidance on how to submit CAF form with the school preferences and
        clarified most of our doubts. Thank you so much Sehyog team for your all
        your efforts.
      </p>
    </div>

    <div class="card-ts">
      <h4 style="font-weight: bold">harita nagula</h4>

      <p style="text-align: justify">
        Sheyog Mocks really helped my Twins to secure a place in ICHS . Mock
        exams made my boys have more confidence and follow the timings and
        instructions. I would recommend to write sheyog mocks to get a real-time
        experience for the main exam. Thank you Sheyog team for giving us free
        sessions as I am an NHS staff .
      </p>
    </div>

    <div class="card-ts">
      <h4 style="font-weight: bold">Mini Dagar</h4>

      <p style="text-align: justify">
        My son attended the mock exams by 11plushelpclub and it helped us a lot.
        With the detailed results every week, we knew which area to work on.
        Topic wise tests were a great form of revision. All the help by whole
        team was fabulous which helped my son to secure a safe place at school
        of his choice. Big thanks to everyone out there for all the help and
        guidance - Mini Dagar
      </p>
    </div>
  </div>
</div>

<div class="faq-sc">
  <p class="faq-sc-title">FAQs</p>

  <div class="drop-d">
    <details>
      <summary>How do I book my GCSE Mock Test?</summary>
      <div>
        <p>
          Select Center and Date on the GCSE Mock Test Calendar and Simply click
          "Book Now"
        </p>
      </div>
    </details>

    <details>
      <summary>Are these tests online or face-to-face?</summary>
      <div>
        <p>We offer both online & offline mock tests.</p>
      </div>
    </details>

    <details>
      <summary>Which exam boards do you cover?</summary>
      <div>
        <p>AQA, Edexcel, OCR – All covered!</p>
      </div>
    </details>
  </div>

  <h3>
    Still have questions? <br />
    Connect Directly on
    <strong style="font-weight: bold">+44 7464772331</strong> & EMAIL
    <strong style="font-weight: bold">academy&#64;sehyog.co.uk</strong>
  </h3>

  <div class="so-sc">
    <img src="assets/images/linkedin.png" alt="linkedin" />
    <img src="assets/images/facebook.png" alt="linkedin" />
    <img src="assets/images/youtube copy.png" alt="linkedin" />
    <img src="assets/images/twitter.png" alt="linkedin" />
    <img src="assets/images/instagram.png" alt="linkedin" />
  </div>

  <p style="width: 80%; margin-top: 100px; text-align: justify">
    SEHYOG is an educational institute dedicated to providing comprehensive
    support to KS2, 11plus, KS3, GCSE & A-Level students to achieve excellence
    in education and personal development with honesty and transparency. The
    sessions, workshops/webinars conducted by SEHYOG do not guarantee 100%
    success in the real exams. No claim is made as to the accuracy or
    authenticity of the content of the sessions, workshops/webinars or the
    information shared via email, website, social media etc. SEHYOG or its
    volunteers/staff do not accept any liability to any person or firm for the
    information or advice (or the use of such information or advice) which is
    provided in the sessions/workshops, email or on social media. The
    information on the website, phone, emails, social media and
    sessions/workshops is provided on the basis that all persons accessing the
    information undertake responsibility for assessing the relevance and
    accuracy of its content.
  </p>
</div>

<!-- pop up -->

<!-- <div class="center-popup" *ngIf="showBoardPopup">
  <div class="popup-content">
    <h3>Select Your Board</h3>
    <div class="center-options">
      <button
        *ngFor="let center of selectedTest?.boards"
        (click)="selectCenter(center)"
      >
        {{ center.name }}
      </button>
    </div>
    <button class="close-btn" (click)="closeBoardDialog()">Close</button>
  </div>
</div> -->

<!-- Microsoft Clarity -->
<script type="text/javascript">
    (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/XXXX";
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "XXXX");
</script>